import { Component} from '@angular/core';

@Component({
  selector: 'app-wbmchlorides-vertical-header',
  standalone: false,
  templateUrl: './wbmchlorides-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class WbmchloridesVerticalHeaderComponent {

}
